module.exports = __webpack_public_path__ + "img/industry3.15c36c88.png";